/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#card-trends {
  .card-title-content {
    display: flex;
    justify-content: space-between;
    margin: variables.$margin-medium 16px variables.$margin-medium variables.$margin-medium;

    .legend.row > div {
      margin-top: variables.$margin-large;
      width: 200px;
      justify-content: flex-start;
      gap: 4px;
      align-items: center;
      img {
        width: 18px;
        aspect-ratio: auto;
      }
    }

    button {
      margin-top: 16px;
      border-color: variables.$color-corpuls-secondary-50;
    }
  }

  .trends-buttons {
    display: flex;
    justify-content: flex-end;
    margin-right: 16px;
  }

  .import-button {
    box-shadow: none;
  }

  .trends-table {
    table-layout: fixed;

    th span {
      color: variables.$color-disabled;
      font-size: variables.$text-size-medium;
      margin-left: variables.$margin-medium;
    }

    .trends-table-cell {
      display: flex;
      gap: variables.$padding-medium;
      align-items: center;

      .trends-check-icon {
        margin: 9px;
      }

      .hide-check {
        visibility: hidden;
      }

      .overwritten-text {
        color: variables.$color-disabled;
      }
    }
  }
}
